/**
 * Returns the base URL for the current environment.
 * Used for constructing URLs that need to point to the correct environment.
 */
export const getEnvironmentUrl = (): string => {
  const currentEnv = window?.location?.href;
  if (currentEnv?.includes('biaiagentp.datalake-sandbox.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_SBX || '';
  if (currentEnv?.includes('qa.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_QA || '';
  if (currentEnv?.includes('prodclone.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_PROD_CLONE || '';
  if (currentEnv?.includes('pc4.preprod.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_PREPROD || '';
  if (currentEnv?.includes('platform.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_PLATFORM || '';
  if (currentEnv?.includes('euqapl.eu-pipeline.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_EU_QA_PLATFORM || '';
  if (currentEnv?.includes('platform.gb.boomi.com')) return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_EU_PROD_PLATFORM || '';
  return process.env.REACT_APP_DEV_REGISTRY_PROXY_TO_SBX || '';
};

export default getEnvironmentUrl;
